import { createContext, useContext, useState } from "react";

type LineItemsLoadingStateContextType = {
  state: Record<string, boolean>;
  setState: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
};

const LineItemsLoadingStateContext =
  createContext<LineItemsLoadingStateContextType>({
    state: {},
    setState: () => {},
  });

export function useLineItemsLoadingState() {
  return useContext(LineItemsLoadingStateContext);
}

export function useLineItemIsLoading(lineItemId: string) {
  const { state } = useLineItemsLoadingState();
  return state[lineItemId] ?? false;
}

export function useSetLineItemIsLoading() {
  const { setState } = useLineItemsLoadingState();
  return (lineItemId: string, isLoading: boolean) => {
    setState((prev) => ({ ...prev, [lineItemId]: isLoading }));
  };
}

export function LineItemsLoadingStateProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, setState] = useState<Record<string, boolean>>({});

  return (
    <LineItemsLoadingStateContext.Provider value={{ state, setState }}>
      {children}
    </LineItemsLoadingStateContext.Provider>
  );
}
